<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form
          ref="form"
          :model="queryParams"
          label-width="80px"
          size="small"
        >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="问题状态：" prop="questionStatus">
                <el-select clearable v-model="queryParams.questionStatus">
                  <template v-for="(value, key) in dictData['question_status']">
                     <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="反馈时间：" prop="time">
                <el-date-picker
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="反馈人：" prop="operNo">
                <el-input v-model="queryParams.operNo" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
        <span style="float:left;"> </span>
      </pagination>
      <el-table  :data="tableData">
        <el-table-column width="170px" label="问题编号" prop="questionId"> </el-table-column>
        <el-table-column
          label="功能模板/页面"
          prop="questionTitle"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="问题与建议描述"
          prop="questionContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="附件信息" prop="">
          <template slot-scope="scope">
            <a v-if="scope.row.attachUrl" :href="scope.row.attachUrl" target="blank">下载附件</a>
          </template>
        </el-table-column>
        <el-table-column label="问题状态" prop="questionStatus">
          <template slot-scope="scope">
            <span>{{
              dictMap["question_status"][scope.row.questionStatus]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="反馈人" prop="operNo"></el-table-column>
        <el-table-column
          label="反馈时间"
          prop="operTime"
          width="180"
        ></el-table-column>
        <el-table-column
          label="回复内容"
          prop="replyContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="处理人" prop="handNo"></el-table-column>
        <el-table-column
          label="处理时间"
          prop="handTime"
          width="180"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleShowEdit(scope.row)"
              >处理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
    <el-dialog :close-on-click-modal="false"   title="问题处理" :visible.sync="dialogVisible" destroy-on-close>
      <div>
        <el-form
          ref="form"
          :model="detailForm"
          :rules="rules"
          label-width="140px"
        >
          <el-row :gutter="24">
            <el-col>
              <el-form-item label="功能模板/页面：">
                {{ this.detailForm.questionTitle }}
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="问题与建议描述：">
                {{ this.detailForm.questionContent }}</el-form-item
              >
            </el-col>
            <el-col>
              <el-form-item label="附件信息：">
                <div class="file-item">
                  <el-row :gutter="24">
                    <el-col :span="18">
                      <div class="el-button--text line-height-40">
                        <a v-if="detailForm.attachUrl" :href="detailForm.attachUrl" target="blank">下载附件</a>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="回复内容：" prop="replyContent">
                <el-input
                  type="textarea"
                  rows="8"
                  v-model="detailForm.replyContent"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSave"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { mapGetters } from "vuex"
import {
  getQuestionList,
  updateQuestion,
} from "@/api/sysSupport/question"

export default {
  components: { Breadcrumb },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        questionStatus: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
        operNo: ''
      },
      loading: false,
      total: 0,
      tableData: [],

      dialogVisible: false,
      detailForm: {},
      rules: {
        replyContent: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
    }
  },

  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    this.getCache('1')
    this.loadData()
  },
  methods: {
    /** 查询问题列表 */
    loadData() {
      this.setCache('1')
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      getQuestionList(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.endLoading()
      }).catch(()=>{
        this.endLoading()
      })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },
    /**显示编辑页面 */
    handleShowEdit(row) {
      this.detailForm = row
      this.dialogVisible = true
    },

    /**保存问题信息 */
    handleSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          updateQuestion(this.detailForm).then((response) => {
            if (response.code == "200") {
              this.msgSuccess("保存成功！")
              this.dialogVisible = false
              this.loadData()
            } else {
              this.msgError("提交失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
